import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { ToggleButton } from 'common/components/Inputs/ToggleGroup/ToggleButton';
import { ToggleGroup } from 'common/components/Inputs/ToggleGroup/ToggleGroup';
import { alertStatusTariffSummaryAtom, AlertStatusType } from 'src/atoms/filters/tariff-summary';

export const AlertStatusSwitch = () => {
  const { t } = useTranslation();
  const [alertStatus, setAlertStatus] = useAtom(alertStatusTariffSummaryAtom);

  return (
    <ToggleGroup
      value={alertStatus}
      onChange={(_event, value) => {
        if (value === null) {
          return;
        }

        setAlertStatus(value);
      }}
      data-testid="alert-status-selector"
      aria-label="Select alert type"
    >
      <ToggleButton value={AlertStatusType.AlertOn} data-testid={'select-alert-status-on'}>
        {t('tariffSummary.table.usageAlert.alertOn')}
      </ToggleButton>
      <ToggleButton value={AlertStatusType.AlertAny} data-testid={'select-alert-status-any'}>
        {t('tariffSummary.table.usageAlert.alertAny')}
      </ToggleButton>
      <ToggleButton value={AlertStatusType.AlertOff} data-testid={'select-alert-status-off'}>
        {t('tariffSummary.table.usageAlert.alertOff')}
      </ToggleButton>
    </ToggleGroup>
  );
};
